import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Label
} from 'reactstrap';

import FormBuilder from './forms/formBuilder';
import { required, emailAddress, dateValidate, duplicateEmail, validateGender } from './forms/validation'

import { formValueSelector, change } from "redux-form"; // ES6
import { connect } from "react-redux";


import { API_ENDPOINT } from '../constants'
import InfoModal from './infoModal';
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}



/**
* A model for entering patient data is displayed if not all required data is available
* @author Milan Stanojevic
*/
class PatientAccountModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            groupObj: null,
            counter: 0,
            donShowFirstLoginModal: true,
            patientDataChanged: false,
            mitidPatientData: true
        }
    }

    componentDidMount() {
        // this._isMounted = true;
        // if (localStorage.getItem('fistLoginData')) {
        //     this.props.verifyUser();
        //     this.setState({
        //         patientData: JSON.parse(localStorage.getItem('fistLoginData')),
        //         success: true,
        //         donShowFirstLoginModal: true
        //     }, () => {
        //         this.update(this.state.patientData)
        //     })
        // } else {
        this.setState({
            donShowFirstLoginModal: false
        })
        // }

        fetch(API_ENDPOINT + '/languages', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                sortType: 1,
                sortField: 'key',
                query: {}
            })
        }).then(parseJSON).then(({ result, status }) => {
            if (status >= 200 && status < 300)
                this.setState({
                    languages: result
                })


        })

        this.getGroupId()



    }

    // componentWillUnmount() {
    //     this._isMounted = false;
    // }

    getPatientData = () => {

        fetch(API_ENDPOINT + '/users/mitId-patient', {
            method: 'POST',
            headers: {
                // 'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ personalNumber: this.props.socialSecurityNumber })
        }).then(parseJSON).then(({ result, status }) => {
            if (status >= 200 && status < 300) {
                // if (this._isMounted)
                this.setState({
                    patientDataChanged: true
                }, () => {
                    // if (this._isMounted) {
                    // if (result && result.email) {
                    //     this.props.changeFormEmail(result.email)
                    // }
                    // if (result && result.phone) {
                    //     this.props.changeFormPhone(result.phone)
                    // }
                    // if (result && result.userData && result.userData.sex) {
                    //     this.props.changeSex(result.userData.sex)
                    // }
                    // }
                    let patientData = this.state.patientData ?? {}
                    patientData.socialSecurityNumber = this.props.socialSecurityNumber
                    patientData.email = result?.email
                    patientData.phone = result?.phone
                    patientData.userData = {
                        name: this.props.name,
                        sex: result?.userData?.sex
                    }
                    this.setState({
                        mitidPatientData: false,
                        patientData
                    }, () => {
                        this.setState({
                            mitidPatientData: true,

                        })
                    })

                })

            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.sex != this.props.sex) {
            if (this.props.sex == 0) {
                this.props.changeSex(null)
            }
        }

        if (prevProps.socialSecurityNumber !== this.props.socialSecurityNumber) {
            if ((this.props.country === 'denmark' && this.props.socialSecurityNumber?.length === 10) || this.props.socialSecurityNumber?.length === 12) {
                let dateOfBirth = this.props.getDateOfBirthFromSSN(this.props.socialSecurityNumber);
                if (dateOfBirth && this.props.changeDateOfBirth) {
                    this.props.changeDateOfBirth(dateOfBirth)
                    if (!this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: true }) }
                } else {
                    if (this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: false }) }
                }


            } else {
                if (this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: false }) }
            }

            this.setState({
                mitIdError: false
            })
        }

        // if (!localStorage.getItem('fistLoginData') && !this.state.success && prevProps.socialSecurityNumber !== this.props.socialSecurityNumber && this.props.country === 'denmark' && this.props.uData && !this.state.patientDataChanged) {
        //     // if (this._isMounted)
        //     this.getPatientData()
        // }

        if (prevProps.socialSecurityNumber !== this.props.socialSecurityNumber && this.props.country === 'denmark' && this.props.uData && !this.state.patientDataChanged) {
            // if (this._isMounted)
            this.getPatientData()
        }

        if (this.props.email && prevProps.email && this.props.email !== prevProps.email) {
            this.setState({
                emailError: false
            })
        }
        if (this.props.uData && prevProps.uData && this.props.uData.mitIdCprVerified !== prevProps.uData.mitIdCprVerified && this.props.uData.mitIdCprVerified) {
            this.setState({
                success: true
            }, () => {
                this.update(this.state.patientData)
            })
        }
    }

    /**
    * Update patient's profile
    * @author Milan Stanojevic
    */
    update = (data) => {
        // form is not updated
        data.language = this.props.uData.language;
        if (this.props.country === 'denmark') {
            data.changeCPR = true;
        }
        if (this.state.redirect_url && this.state.userVerification) return;
        if (this.props.country === 'denmark' && !this.state.success && this.props.uData?.mitIdHasCpr) {
            let groupAlias;
            if (typeof window != 'undefined' && localStorage.groupAlias) {
                groupAlias = localStorage.groupAlias;
            } else if (this.props[0].match.params.alias) {
                groupAlias = this.props[0].match.params.alias;
            }

            this.setState({
                patientData: data
            }, () => {
                // localStorage.setItem('fistLoginData', JSON.stringify(data))
            })
            fetch(API_ENDPOINT + '/users/mitID/verify/crp', {
                method: 'POST',
                headers: {
                    // 'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ personalNumber: data.socialSecurityNumber, user: this.props.uData._id, alias: groupAlias })
            }).then(parseJSON).then(({ result, status }) => {

                // if (result && result.redirect_url) {
                //     this.setState({
                //         redirect_url: result.redirect_url,
                //         userVerification: true
                //     })
                // }
                if (result.verifyCpr) {
                    this.props.verifyUser();
                    this.setState({
                        // patientData: JSON.parse(localStorage.getItem('fistLoginData')),
                        success: true,
                        // donShowFirstLoginModal: true
                    }, () => {
                        this.update(this.state.patientData)
                    })
                } else if (result.error) {
                    if (status === 400) {
                        this.setState({
                            logoutError: "Too many failed attempts. Please try again".translate(this.props.lang),
                        })

                        // this.props.signOut();
                        return;
                    }
                    this.setState({
                        mitIdError: result.error.translate(this.props.lang),
                        donShowFirstLoginModal: false,
                        success: false
                    })
                }


            })
        } else {
            // if (this.props.country === 'denmark' && this.props.uData?.mitIdHasCpr && !this.props.uData?.mitIdCprVerified) {
            //     this.setState({
            //         mitIdError: 'Login successful but CPR number did not match the one provided in the request'.translate(this.props.lang),
            //         donShowFirstLoginModal: false,
            //         success: false
            //     })
            //     return
            // }

            fetch(API_ENDPOINT + '/users/account/update', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {

                if (result.error) {
                    this.setState({ error: result.error.translate(this.props.lang) })
                } else if (result.emailError) {
                    this.setState({
                        emailError: result.emailError.translate(this.props.lang)
                    })
                } else {

                    this.setState({
                        message: result.message
                    })
                    if (result.jwtToken) {
                        localStorage.setItem('authToken', result.jwtToken);
                    }

                    this.props.verifyUser(() => {
                        if (localStorage.getItem('newUserDataMitId')) {
                            this.setState({
                                mitIdDataAfterRedirect: JSON.parse(localStorage.getItem('newUserDataMitId'))
                            }, () => {
                                this.props[0].history.push({
                                    pathname: this.state.mitIdDataAfterRedirect?.redirectLink ?? '/my-data/account',
                                    state: {
                                        mitIdDataAfterRedirect: this.state.mitIdDataAfterRedirect,
                                        referral: this.state.mitIdDataAfterRedirect?.referral,
                                        selectedReferral: this.state.mitIdDataAfterRedirect?.selectedReferral,
                                        clinicGroup: this.state.mitIdDataAfterRedirect?.clinicGroup,
                                        isDropIn: this.state.mitIdDataAfterRedirect?.isDropIn,
                                        selectedDropInForm: this.state.mitIdDataAfterRedirect?.selectedDropInForm,
                                        tabIndex: this.state.mitIdDataAfterRedirect?.tabIndex,
                                    }
                                })
                            })

                        }
                    });



                    // localStorage.removeItem('fistLoginData')
                }

            })
        }



    }

    updateLanguage = (data) => {
        this.setState(
            {
                loadLang: true
            },
            () => {
                fetch(API_ENDPOINT + "/users/account/update-userdata", {
                    method: "POST",
                    headers: {
                        Authorization:
                            typeof localStorage !== "undefined"
                                ? `Bearer ${localStorage.getItem("authToken")}`
                                : null,
                        "content-type": "application/json",
                    },
                    body: JSON.stringify(data),
                })
                    .then(parseJSON)
                    .then(({ result, status }) => {
                        if (result) {
                            this.props.verifyUser()


                        }
                    });
            }
        );
    };
    getGroupId = () => {
        let groupAlias;
        if (typeof window != 'undefined' && localStorage.groupAlias) {
            groupAlias = localStorage.groupAlias;
        } else if (this.props[0].match.params.alias) {
            groupAlias = this.props[0].match.params.alias;
        }

        if (groupAlias) {


            fetch(API_ENDPOINT + "/data/clinic-group/info", {
                method: "POST",
                headers: {
                    Authorization:
                        typeof localStorage !== "undefined"
                            ? `Bearer ${localStorage.getItem("authToken")}`
                            : null,
                    "content-type": "application/json",
                },
                body: JSON.stringify({ alias: groupAlias }),
            }).then(parseJSON).then(({ result, status }) => {
                if (result && result._id) {
                    this.setState({ groupObj: result })

                }
                this.props.verifyUser()
            });
        }

    }

    render() {
        const { groupObj } = this.state;
        let showPrivacyPolicyCheckbox = false;
        if (this.state.groupObj && this.state.groupObj._id && this.props.uData && (this.props.uData.userLevel === 1 || this.props.uData.userLevel === 2 || (this.props.uData.userLevel === 20 && typeof window != 'undefined' && localStorage?.getItem?.('profile') === 'patient')) && (!this.props.uData.privacyPolicy || !this.props.uData.privacyPolicy[String(this.state.groupObj?._id)])) {
            showPrivacyPolicyCheckbox = true
        }
        let label2;

        if (showPrivacyPolicyCheckbox) {
            let privacyPolicy = groupObj.privacyPolicy && groupObj.privacyPolicy.file ? `${API_ENDPOINT}${groupObj.privacyPolicy.file}` : null;

            label2 =
                <div className='privacy-policy-field-label-wrap' style={{ marginTop: 20 }}>
                    <p style={{ fontSize: 14 }}> {'You can read about how we handle your personal data:'.translate(this.props.lang)} {privacyPolicy ? <a href={privacyPolicy} target="_blank">{'Privacy Policy'.translate(this.props.lang)}</a> : 'Privacy Policy'.translate(this.props.lang)}.</p>

                </div>
        }
        if (typeof window !== 'undefined' && localStorage?.hidePatientModal) {
            return null;
        }

        if (this.state.logoutError) {
            return (

                <InfoModal
                    isOpen={this.state.logoutError}

                    toggle={() => this.setState({ logoutError: null }, () => {
                        this.props.signOut(false, true);
                    })}
                    // header={'Error'.translate(this.props.lang)}
                    info={this.state.logoutError}
                    buttons={[
                        <Button color='primary' onClick={() => {
                            this.setState({
                                logoutError: null
                            }, () => {
                                this.props.signOut(false, true);
                            })

                        }}>{'Ok'.translate(this.props.lang)}</Button>
                    ]}
                />
            )
        }

        return (
            <Modal isOpen={this.props.patientAccountModal && !this.state.donShowFirstLoginModal} centered zIndex={1060} backdrop='static'>

                <ModalHeader style={{ display: 'block', width: '100%' }}>
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p style={{ width: '50%', marginBottom: 0 }}>{'My profile'.translate(this.props.lang)}</p>
                        {!this.props.secondaryLanguageDisabled ? <select className='select-lang-patient-account-modal'
                            value={this.props.uData && this.props.uData.language}
                            onChange={(e) => {
                                this.updateLanguage({ language: e.target.value });

                            }}
                        >

                            {this.state.languages &&
                                this.state.languages.map((item, idx) => {
                                    return (
                                        <option key={idx} value={item?._id}>
                                            {item.name?.translate(this.props.lang)}
                                        </option>
                                    );
                                })}

                        </select> : null}
                    </div>



                </ModalHeader>
                <ModalBody className="bankid-modal">
                    {
                        this.props.uData && this.state.mitidPatientData ?
                            <FormBuilder selectedGroup={this.props.selectedGroup} selectedClinic={this.props.selectedClinic} countryTwoLetter={this.props.countryTwoLetter} country={this.props.country} dateFormat={this.props.dateFormat}
                                getStringDateTs={this.props.getStringDateTs}
                                lang={this.props.lang}
                                onSubmit={(data) => {
                                    if (showPrivacyPolicyCheckbox) {
                                        if (!data.privacyPolicy) {
                                            data.privacyPolicy = {}
                                        }
                                        if (groupObj && groupObj._id)
                                            data.privacyPolicy[groupObj._id] = true;
                                    }
                                    if (this.props.country === 'denmark') {
                                        this.setState({
                                            dataBeofreUpdate: data
                                        })
                                    }
                                    this.update(data)
                                }}
                                hideSubmitButton={this.state.userVerification}
                                initialValues={this.state.patientData ? this.state.patientData : this.props.uData}
                                toggle={() => this.setState({ form: null })}
                                invalidMessage={"Please fill in required fields".translate(this.props.lang)}
                                buttonText={showPrivacyPolicyCheckbox ? 'Agree to Terms of Service and continue'.translate(this.props.lang) : 'Save'.translate(this.props.lang)}
                                buttonsWrapClassName={'empty'}
                                afterTextComponent={label2}
                                additionalBeforeButton={
                                    this.props.socialSecurityNumber && this.state.userVerification && this.state.redirect_url && this.props.socialSecurityNumber.length === 10 && this.props.country === 'denmark' ?
                                        <div>
                                            <a className='mitid-verify-cpr' href={this.state.redirect_url}>
                                                {"Please verify you CPR number".translate(this.props.lang)}
                                            </a>
                                        </div>
                                        :
                                        null

                                }
                                additionalAdditionalBeforeButton={
                                    <div style={{ width: '100%' }}>
                                        {
                                            this.state.emailError || this.state.error || this.state.mitIdError ? (
                                                <p style={{ color: 'red' }}>{this.state.emailError || this.state.error || this.state.mitIdError}</p>
                                            )
                                                :
                                                null
                                        }
                                    </div>
                                }
                                additionalButton={
                                    this.props.uData && this.props.uData.userLevel == 20 ?
                                        <Button color="danger" onClick={() => {
                                            let urlSplit = this.props[0].location.pathname.split('/');
                                            let url = '/' + urlSplit[1];
                                            this.props[0].history.push(url)
                                        }}>{'Cancel'.translate(this.props.lang)}</Button>
                                        :
                                        <Button color="danger" onClick={() => this.props.signOut()}>{'Logout'.translate(this.props.lang)}</Button>
                                }
                                fields={[
                                    {
                                        type: 'row',
                                        children: [
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'socialSecurityNumber',
                                                        disabled: this.props.country === 'denmark' || this.props.uData?.socialSecurityNumber === '' || this.props.uData?._arbitraryDob ? false : true,
                                                        name: 'socialSecurityNumber',
                                                        label: this.props.country === 'uk' ? "Date of birth".translate(this.props.lang) : 'Social security number'.translate(this.props.lang),
                                                        getCountryState: (countryState) => {
                                                            let countryStateDict = this.state.countryStateDict ?? {};
                                                            countryStateDict['socialSecurityNumber'] = countryState;
                                                            this.setState({ countryStateDict })
                                                        },
                                                        validate: [required('Social security number is required!'.translate(this.props.lang))],
                                                        labelInfo: this.props.uData?._arbitraryDob ? 'Your date of birth has been added arbitrarily. Please enter your real date of birth!'.translate(this.props.lang) : undefined,
                                                    },
                                                ]
                                            },

                                            groupObj?.patientInfoSettings?.isCustomIdEnabled && {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: `customId.${groupObj?._id}`,
                                                        label: groupObj?.patientInfoSettings?.customIdLabel ?? 'Custom id'.translate(this.props.lang),
                                                        labelInfo: groupObj?.patientInfoSettings?.customIdInfoText ?? null,
                                                        validate: groupObj?.patientInfoSettings?.isCustomIdRequired ? [required(groupObj?.patientInfoSettings?.customIdLabel ? groupObj?.patientInfoSettings?.customIdLabel + ' ' + `is required!`.translate(this.props.lang) : 'Custom id is required!'.translate(this.props.lang))] : [],
                                                    },
                                                ]
                                            },
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'userData.name',
                                                        label: 'First and last name'.translate(this.props.lang),
                                                        // disabled: this.props.alias,
                                                        disabled: this.props.uData && this.props.uData.userData && this.props.uData.userData.name ? true : false,
                                                        validate: [required('First and last name is required!'.translate(this.props.lang))]

                                                    },
                                                ]
                                            },
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'gender',
                                                        name: 'userData.sex',
                                                        labelInfo: "Your biological sex is needed for proper treatment".translate(this.props.lang),
                                                        // validate: [required('Sex is required!'.translate(this.props.lang))]
                                                        groupData: groupObj,
                                                        validate: [validateGender(groupObj?.patientInfoSettings?.canHaveOtherGender === true, this.props.lang)]
                                                    },
                                                ]
                                            },
                                            this.props.showDateOfBirth ?
                                                {
                                                    type: 'col',
                                                    width: {
                                                        lg: 12,
                                                        sm: 12,
                                                        xs: 12
                                                    },
                                                    children: [
                                                        {
                                                            type: 'date-of-birth',
                                                            dateFormat: this.props.dateFormat,
                                                            name: 'dateOfBirth.date',
                                                            disabled: this.state.disabledDateOfBirth,
                                                            label: 'Date of birth'.translate(this.props.lang),
                                                            validate: [required('Date of birth is required!'.translate(this.props.lang)), dateValidate('Invalid date!'.translate(this.props.lang))]

                                                        },
                                                    ]
                                                } : null,
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'email',
                                                        name: 'email',
                                                        label: 'Email address'.translate(this.props.lang),
                                                        validate: [required('Email address is required!'.translate(this.props.lang)), emailAddress('Invalid email address!'.translate(this.props.lang)), duplicateEmail(this.state.emailError, this.state.emailError)]
                                                    },
                                                ]
                                            },
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'phone',
                                                        name: 'phone',
                                                        label: 'Phone number'.translate(this.props.lang),
                                                        validate: [required('Phone number is required!'.translate(this.props.lang))]
                                                    },
                                                ]
                                            },
                                            // {
                                            //     type: 'col',
                                            //     width: {
                                            //         lg: 12,
                                            //         sm: 12,
                                            //         xs: 12
                                            //     },
                                            //     children: [
                                            //         {
                                            //             type: 'text',
                                            //             name: 'street',
                                            //             label: 'Street'.translate(this.props.lang),
                                            //             validate: [required('Street is required!'.translate(this.props.lang))]
                                            //         },
                                            //     ]
                                            // },
                                            // {
                                            //     type: 'col',
                                            //     width: {
                                            //         lg: 3,
                                            //         sm: 12,
                                            //         xs: 12
                                            //     },
                                            //     children: [
                                            //         {
                                            //             type: 'text',
                                            //             name: 'zip',
                                            //             // pattern: new RegExp(/[0-9 ]+/i),
                                            //             label: 'Postal code'.translate(this.props.lang),
                                            //             validate: [required('Postal code is required!'.translate(this.props.lang))]
                                            //         },
                                            //     ]
                                            // },
                                            // {
                                            //     type: 'col',
                                            //     width: {
                                            //         lg: 9,
                                            //         sm: 12,
                                            //         xs: 12
                                            //     },
                                            //     children: [
                                            //         {
                                            //             type: 'text',
                                            //             name: 'city',
                                            //             // pattern: new RegExp(/^[a-zA-Z \u00c0-\u017e]$/i),
                                            //             pattern: new RegExp(/^[a-zA-Z \u00c0-\u017e\u0370-\u03FF ]$/i),
                                            //             label: 'City'.translate(this.props.lang),
                                            //             validate: [required('City is required!'.translate(this.props.lang))]
                                            //         },
                                            //     ]
                                            // },
                                            // {
                                            //     type: "col",
                                            //     width: {
                                            //         lg: 12,
                                            //         sm: 12,
                                            //         xs: 12,
                                            //     },
                                            //     style: { padding: 0, marginTop: 15 },
                                            //     children: [
                                            //         {
                                            //             type: "col",
                                            //             width: {
                                            //                 lg: 12,
                                            //                 sm: 12,
                                            //                 xs: 12,
                                            //             },
                                            //             children: [
                                            //                 {
                                            //                     type: "h6",
                                            //                     text: 'Related parties login'.translate(this.props.lang)
                                            //                 },
                                            //             ],
                                            //         },
                                            //         {
                                            //             type: "col",
                                            //             width: {
                                            //                 lg: 12,
                                            //                 sm: 12,
                                            //                 xs: 12,
                                            //             },

                                            //             children: [
                                            //                 {
                                            //                     type: "hr",
                                            //                 },
                                            //             ],
                                            //         },
                                            //     ],
                                            // },

                                            // {
                                            //     type: "col",
                                            //     width: {
                                            //         lg: 6,
                                            //         sm: 12,
                                            //         xs: 12,
                                            //     },
                                            //     children: [
                                            //         {
                                            //             type: "text",
                                            //             name: "userData.relatedParties.name",
                                            //             label: "Name".translate(
                                            //                 this.props.lang
                                            //             ),
                                            //         },
                                            //     ],
                                            // },
                                            // {
                                            //     type: "col",
                                            //     width: {
                                            //         lg: 6,
                                            //         sm: 12,
                                            //         xs: 12,
                                            //     },
                                            //     children: [
                                            //         {
                                            //             type: "text",
                                            //             name: "userData.relatedParties.relations",
                                            //             label: "Relations".translate(
                                            //                 this.props.lang
                                            //             ),
                                            //         },
                                            //     ],
                                            // },

                                            // {
                                            //     type: "col",
                                            //     width: {
                                            //         lg: 6,
                                            //         sm: 12,
                                            //         xs: 12,
                                            //     },
                                            //     style: { padding: 0 },
                                            //     children: [
                                            //         {
                                            //             type: "col",
                                            //             width: {
                                            //                 lg: 12,
                                            //                 sm: 12,
                                            //                 xs: 12,
                                            //             },
                                            //             children: [
                                            //                 {
                                            //                     type: "phone",
                                            //                     name: "userData.relatedParties.phone",
                                            //                     label: "Phone 1".translate(
                                            //                         this.props.lang
                                            //                     ),
                                            //                 },
                                            //             ],
                                            //         },
                                            //         {
                                            //             type: "col",
                                            //             width: {
                                            //                 lg: 12,
                                            //                 sm: 12,
                                            //                 xs: 12,
                                            //             },

                                            //             children: [
                                            //                 {
                                            //                     type: "phone",
                                            //                     name: "userData.relatedParties.phone2",
                                            //                     label: "Phone 2".translate(
                                            //                         this.props.lang
                                            //                     ),
                                            //                 },
                                            //             ],
                                            //         },
                                            //     ],
                                            // },


                                            // {
                                            //     type: "col",
                                            //     width: {
                                            //         lg: 6,
                                            //         sm: 12,
                                            //         xs: 12,
                                            //     },
                                            //     children: [
                                            //         {
                                            //             type: "textarea",
                                            //             name: "userData.otherInformations",
                                            //             height: 152,
                                            //             label: "Other information".translate(
                                            //                 this.props.lang
                                            //             ),
                                            //         },
                                            //     ],
                                            // },
                                            showPrivacyPolicyCheckbox ?
                                                {
                                                    type: "col",
                                                    width: {
                                                        lg: 12,
                                                        sm: 12,
                                                        xs: 12,
                                                    },
                                                    children: [
                                                        {
                                                            type: "privacy-policy-checkbox",
                                                            name: `privacyPolicy.${groupObj?._id}`,
                                                            groupData: groupObj,
                                                            lang: this.props.lang,
                                                            // validate: [required('Privacy Policy is required!'.translate(this.props.lang))],
                                                            firstLogin: true,
                                                        },
                                                    ],
                                                }
                                                :
                                                {
                                                    type: 'empty'
                                                },


                                            // {
                                            //     type: 'col',
                                            //     width: {
                                            //         lg: 6,
                                            //         sm: 12,
                                            //         xs: 12
                                            //     },
                                            //     children: [
                                            //         {
                                            //             type: 'select',
                                            //             name: 'language',
                                            //             label: 'Language'.translate(this.props.lang),
                                            //             values: this.state.languages.map(item => { return { name: item.name, value: item._id } }),
                                            //         },
                                            //     ]
                                            // },


                                            // {
                                            //     type: 'col',
                                            //     width: {
                                            //         lg: 6,
                                            //         sm: 12,
                                            //         xs: 12
                                            //     },
                                            //     children: [
                                            //         {
                                            //             type: 'checkbox',
                                            //             name: 'notifications.email',
                                            //             afterText: 'E-mail notification'.translate(this.props.lang),
                                            //         },
                                            //         {
                                            //             type: 'checkbox',
                                            //             name: 'notifications.sms',
                                            //             afterText: 'SMS notification'.translate(this.props.lang),
                                            //         },

                                            //     ]
                                            // },




                                        ]
                                    }
                                ]}
                            ></FormBuilder>
                            :
                            null

                    }
                    <p className="error-message">{this.state.error}</p>

                    {/* {
                        this.state.userVerification && this.props.socialSecurityNumber && this.props.socialSecurityNumber.length === 10 && this.props.country === 'denmark' ?
                            <InfoModal
                                isOpen={this.state.userVerification}

                                toggle={() => this.setState({ userVerification: null })}
                                header={'Info'.translate(this.props.lang)}
                                info={"Please verify you CPR number".translate(this.props.lang)}
                                buttons={[
                                    <a className='btn btn-primary' href={this.state.redirect_url}>
                                        {"Vefify you CPR number".translate(this.props.lang)}
                                    </a>
                                ]}
                            />
                            :
                            null
                    } */}
                </ModalBody>
            </Modal>
        )
    }
}

// export default PatientAccountModal;

const selector2 = formValueSelector("form");


export default connect(
    (state) => {
        return {
            sex: selector2(state, 'userData.sex'),
            socialSecurityNumber: selector2(state, 'socialSecurityNumber'),
            dateOfBirth: selector2(state, 'dateOfBirth.date'),
            email: selector2(state, 'email'),
            phone: selector2(state, 'phone'),
            name: selector2(state, 'userData.name')
        };
    },
    {
        changeSex: (value) => change("form", "userData.sex", value),
        changeFormEmail: (value) => change("form", "email", value),
        changeFormPhone: (value) => change("form", "phone", value),
        changeDateOfBirth: value => change("form", "dateOfBirth.date", value),

    }
)(PatientAccountModal);
